import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import { ImageUtils } from "@/lib/gooroomee/image-process/ImageUtils";
import { ImageUtilsWorker } from "@/lib/gooroomee/image-process/ImageUtilsWorker";

export default class GrmSelfieSegmentation {
    options={}
    _props = {
        monitor: []
    }

    constructor(options) {
        Object.assign(this.options, options);
    }

    async init () {
        if(this.selfieSegmentation){
            return this;
        }

        const {options} = this;
        if(!options.selfieSegmentation) options.selfieSegmentation = {};
        await (async () => {
            const createOptions = Object.assign({
                locateFile: (file) =>
                    `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation@latest/${file}`,
            }, options.selfieSegmentation);
            this.selfieSegmentation = new SelfieSegmentation(createOptions);
            this.selfieSegmentation.setOptions({
                modelSelection: 1, // 0: 상반신 (빠름), 1: 전신 (정확)
                // selfieMode: true,
            });

            Object.assign(this._props, {
                createOptions,
            })

            // 초기화 오류가 발생하여 delay 시도.
            return new Promise((resolve, reject) => {
                setTimeout(resolve, 300);
            });
        })();
    }

    async detectForPerson (imageData, options) {
        // if(globalThis.HTMLVideoElement && imageData instanceof globalThis.HTMLVideoElement){
        //     if(imageData.videoWidth < 1){
        //         console.error('', imageData.videoWidth, imageData.videoHeight, imageData.networkState, imageData.paused);
        //     }
        //     imageData = await createImageBitmap(imageData);
        // }
        const results = await new Promise((resolve, reject) => {
            this.selfieSegmentation.onResults((results) => {
                this.selfieSegmentation.onResults(null);
                resolve(results);
            });
            try{
                this.selfieSegmentation.send({ image: imageData })
                    .catch(e => {
                        console.trace('send error', e);
                        reject(e);
                    });
            }catch(e){
                console.trace(e);
                throw e;
            }
        });

        const image = results.segmentationMask;
        if(options?.onMask){
            await options.onMask(image);
        }
        let {
            findPixels, totalPixels,
            rate
        } = await (async () => {
            let transImageSize = this._props.imageParseLimitSize || 90
            const utils = await (async () => {
                if(this.options.useImageUtilsWorker === false){
                    return ImageUtils;
                }
                return await ImageUtilsWorker.get()
            })()
            // const utils = ImageUtils;
            const result = await utils.getImageAlphaPixelCount({
                image, transImageSize,
                availAlphaCount: 128
            });
            return result;
        })();

        const personRate = this._props.personRate || 0.03;
        return {
            results,
            parseData: {
                findPixels, totalPixels,
                rate
            },
            hasPerson: rate >= personRate,
            image
        }
    }

    async _detectForPerson (image) {
        // if(globalThis.HTMLVideoElement && image instanceof HTMLVideoElement){
        //     image = await createImageBitmap(image);
        // }
        const results = await new Promise((resolve, reject) => {
            this.selfieSegmentation.onResults((results) => {
                this.selfieSegmentation.onResults(null);
                resolve(results);
            });
            this.selfieSegmentation.send({ image });
        });

        let parseData = (() => {
            const imageBitmap = results.segmentationMask;
            const {canvas, ctx} = (() => {
                let {pCanvas, pCtx} = this._props;
                if(!pCanvas){
                    pCanvas = this._props.pCanvas = (() => {
                        if(globalThis.OffscreenCanvas){
                            return new OffscreenCanvas(1, 1);
                        }
                        return globalThis.document?.createElement('canvas');
                    })();
                    pCtx = this._props.pCtx = pCanvas.getContext('2d', {willReadFrequently: true});
                }
                return {canvas:pCanvas, ctx: pCtx};
            })();

            const limitSize = this._props.imageParseLimitSize || 360;

            let scale = 1;
            if(imageBitmap.width > limitSize || imageBitmap.height > limitSize){
                scale = Math.max(
                    limitSize / imageBitmap.width,
                    limitSize / imageBitmap.height
                );
            }

            canvas.width = Math.floor(imageBitmap.width * scale);
            canvas.height = Math.floor(imageBitmap.height * scale);

            ctx.drawImage(imageBitmap, 0, 0);

            // pixel data (RGBA)
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const pixels = imageData.data; // Uint8ClampedArray (RGBA)

            let personPixelCount = 0;
            const totalPixels = pixels.length / 4; // RGBA
            // const personCheckSize = totalPixels * personCheckRatio;

            // 밝은 픽셀(사람) 수
            for (let i = 0; i < pixels.length; i += 4) {
                const alpha = pixels[i + 3]; // Alpha 값 (0~255)
                if (alpha > 128) personPixelCount++; // 50% 이상 불투명하면 사람으로 간주
                // if(personPixelCount > personCheckSize) break;
            }

            return {
                personPixelCount,
                totalPixels,
                rate: personPixelCount / totalPixels
            }
        })();

        const personCheckRate = this._props.personCheckRate || 0.03;
        return {
            results,
            parseData,
            hasPerson: parseData.rate >= personCheckRate,
            image: this._props.pCanvas
        }
    }

    async detectMonitorForVideo ({
      video,
      detectIntervalMs,
      onMask,
      callback
    }) {
        const {monitor} = this._props;
        const id = 'smt-'+performance.now();

        const RunData = {
            id,
            video,
            stream: video.srcObject,
            run: true,
            destroy: false,
            timer: null,
            lastVideoTime: -1,
            detectCount: 0,
            callbackData: {
                changeDetectIntervalMs: (ms) => {
                    if(detectIntervalMs !== ms && video.srcObject){
                        const track = video.srcObject.getVideoTracks()[0];
                        if(track){
                            const frameRate = track.getSettings().frameRate;
                            ms = Math.max(ms, 1000 / frameRate);
                        }
                    }

                    detectIntervalMs = ms;
                    if(RunData.run){
                        if(RunData.runTimer){
                            clearTimeout(RunData.runTimer);
                        }
                        RunData.runTimer = setTimeout(() => {
                            delete RunData.runTimer;
                            if(video.requestVideoFrameCallback){
                                video.requestVideoFrameCallback(segmentVideo);
                            }else{
                                globalThis.requestAnimationFrame(segmentVideo);
                            }
                        }, detectIntervalMs || 1000);
                    }
                },
                isRunning: () => {
                    return !!RunData.run;
                },
                pause: () => {
                    if(!RunData.run) return;
                    clearTimeout(RunData.runTimer);
                    RunData.run = false;
                    if(video._selfie_){
                        video.pause();
                    }
                },
                resume: () => {
                    if(RunData.destroy){
                        throw 'destroyed';
                    }
                    if(RunData.run) return;
                    RunData.run = true;
                    RunData.lastVideoTime = video.currentTime;
                    segmentVideo();
                },
                destroy: function(){
                    if(RunData.destroy) return;
                    this.pause();
                    if(video._selfie_){
                        video.srcObject = null;
                    }
                    let idx = monitor.findIndex(m => m === RunData);
                    if(idx > -1){
                        monitor.splice(idx, 1);
                    }
                    RunData.destroy = true;
                },
                isDestroyed: function(){
                    return RunData.destroy;
                }
            }
        };

        const segmentVideo = async () => {
            if(!RunData.run){
                return;
            }
            let paused = video.paused;
            if (RunData.lastVideoTime !== video.currentTime) {
                if (RunData.lastVideoTime !== video.currentTime) {
                    RunData.lastVideoTime = video.currentTime;
                }
                try{
                    const result = await this.detectForPerson(video, {onMask});
                    Object.assign(RunData.callbackData, {
                        data: result,
                    });
                    callback(RunData.callbackData);
                }catch(e){
                    console.error(e);
                }
            }else if(video.currentTime === 0){
                if(
                    isNaN(video.duration)
                    || !video.srcObject
                    || !video.src
                ){
                    paused = true;
                }
            }

            if(paused){
                return;
            }
            RunData.callbackData.changeDetectIntervalMs(detectIntervalMs || 1000)
        }

        if(video.paused){
            video.addEventListener('playing', e => {
                segmentVideo();
            });
            video.play().catch(e => {
                console.error(e);
            })
        }else{
            segmentVideo();
        }
        monitor.push(RunData);
    }

    async segmentMonitorForStream ({
        stream,
        detectIntervalMs,
        callback
    }) {
        const video = document.createElement('video');
        video.muted = true;
        video.playsInline = true;
        video.srcObject = stream;
        video._selfie_ = true;

        this.detectMonitorForVideo({video, detectIntervalMs, callback});
    }
}